import { defineMessages } from 'react-intl';

const namespace = 'crdf_modals_updateBankAccount';

export default defineMessages({
  title: {
    id: `${namespace}_title`,
    defaultMessage: 'Účet pro výplatu pojistného plnění',
  },
  button_cancel: {
    id: `${namespace}_buttonCancel`,
    defaultMessage: 'Zrušit',
  },
  button_save: {
    id: `${namespace}_buttonSave`,
    defaultMessage: 'Uložit',
  },
  checkbox: {
    id: `${namespace}_checkbox`,
    defaultMessage: 'Vlastníkem účtu je jiná osoba',
  },
  bankAccountLabel: {
    id: `${namespace}_bankAccountLabel`,
    defaultMessage: 'Účet pro výplatu plnění',
  },
  bankAccountNumberHelpInfo: {
    id: `${namespace}_bankAccountNumberHelpInfo`,
    defaultMessage:
      'Číslo bankovního účtu obsahující předčíslí uveďte prosím ve tvaru XXXXXX-XXXXXXXXXX',
  },
  modalButton: {
    id: `${namespace}_modalButton`,
    defaultMessage: 'Upravit',
  },
  bankAccountNumberLabel: {
    id: `${namespace}_bankAccountNumberLabel`,
    defaultMessage: 'Číslo účtu',
  },
  bankCodeLabel: {
    id: `${namespace}_bankCodeLabel`,
    defaultMessage: 'Kód banky',
  },
  notOwnerLabel: {
    id: `${namespace}_notOwnerLabel`,
    defaultMessage: 'Vlastníkem účtu je jiná osoba',
  },
  bankAccountOwnerInfo: {
    id: `${namespace}_bankAccountOwnerInfo`,
    defaultMessage: 'Údaje o vlastníkovi účtu',
  },
  firstNameLabel: {
    id: `${namespace}_firstNameLabel`,
    defaultMessage: 'Jméno',
  },
  lastNameLabel: {
    id: `${namespace}_lastNameLabel`,
    defaultMessage: 'Příjmení',
  },
  birthDateLabel: {
    id: `${namespace}_birthDateLabel`,
    defaultMessage: 'Datum narození',
  },
  nationalityLabel: {
    id: `${namespace}_nationalityLabel`,
    defaultMessage: 'Státní příslušnost',
  },
  addressHeading: {
    id: `${namespace}_addressHeading`,
    defaultMessage: 'Trvalá adresa vlastníka účtu',
  },
  streetLabel: {
    id: `${namespace}_streetLabel`,
    defaultMessage: 'Ulice a č.p.',
  },
  cityLabel: {
    id: `${namespace}_cityLabel`,
    defaultMessage: 'Město',
  },
  postalCodeLabel: {
    id: `${namespace}_postalCodeLabel`,
    defaultMessage: 'PSČ',
  },
  countryLabel: {
    id: `${namespace}_countryLabel`,
    defaultMessage: 'Stát',
  },
  stepFive_backButtonLabel: {
    id: `${namespace}_backButtonLabel`,
    defaultMessage: 'Zrušit',
  },
  stepFive_continueButtonLabel: {
    id: `${namespace}_continueButtonLabel`,
    defaultMessage: 'Uložit',
  },
});
